import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ajax-loader"
export default class extends Controller {
  connect() {
    this.originalCursor = document.body.style.cursor;

    document.addEventListener("turbo:submit-start", this.start.bind(this));
    document.addEventListener("turbo:submit-end", this.stop.bind(this));
  }

  disconnect() {
    document.removeEventListener("turbo:submit-start", this.start.bind(this));
    document.removeEventListener("turbo:submit-end", this.stop.bind(this));
  }

  start() {
    document.body.style.cursor = "wait";
  }

  stop() {
    document.body.style.cursor = this.originalCursor;
  }
}
